import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { ROUTES_MAP } from "../../routes/constants";
import { PageTemplate } from "../../templates/PageTemplate/PageTemplate";

import First from "./steps/One";
import TwoNew from "./steps/Two";
import Three from "./steps/Three";
import Four from "./steps/Four";

export const CONFIG_MANAGER_LIGHT_STEPS = {
    one: "step-one",
    two: "step-two",
    three: "step-three",
    four: "step-four"
};

const ConfigManager = () => {
    const baseUrl = ROUTES_MAP.configManagerLite.path;

    return (
        <PageTemplate>
            <Switch>
                <Route
                    path={`${baseUrl}/${CONFIG_MANAGER_LIGHT_STEPS.one}`}
                    exact
                    component={First}
                />

                <Route
                    path={`${baseUrl}/${CONFIG_MANAGER_LIGHT_STEPS.two}`}
                    exact
                    component={TwoNew}
                />

                <Route
                    path={`${baseUrl}/${CONFIG_MANAGER_LIGHT_STEPS.three}`}
                    exact
                    component={Three}
                />

                <Route
                    path={`${baseUrl}/${CONFIG_MANAGER_LIGHT_STEPS.four}`}
                    exact
                    component={Four}
                />

                <Redirect to={`${baseUrl}/${CONFIG_MANAGER_LIGHT_STEPS.one}`} />
            </Switch>
        </PageTemplate>
    );
};

export default ConfigManager;
